import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";

import { useTranslation } from "@hooks/useTranslation";

import experiencesImg from "@assets/activities-tab.png";
import placesToVisitImg from "@assets/mustsee_v2.png";
import hotelsImg from "@assets/hotels.png";
import Cookies from "js-cookie";

export type TabSlug = "exp" | "plc" | "htl";

export default function TabsSearch() {
  const {
    pathname,
    query: { id: cityId },
  } = useRouter();

  const { t } = useTranslation();

  const tabs = [
    {
      title: t("spotprofile.places"),
      slug: "plc" as TabSlug,
      img: placesToVisitImg,
    },
    /*
    {
      title: t("spotprofile.experiences.title"),
      slug: "exp" as TabSlug,
      img: experiencesImg,
    }*/
  ];


  const handleClick = (tab: string) => {
    Cookies.set('SPOTFILTER', tab);
  }

  return (
    <div className="flex items-center justify-center w-full md:gap-x-16 lg:gap-x-2">
      {tabs.map(({ title, slug, img }) => {
        const isActiveTab = pathname.includes(slug);


        return (
          <Link
            key={slug}
            href={`/spotprofiles/${cityId}/${slug}`}
            className="flex flex-col lg:flex-row items-center justify-center px-2 gap-2"
            onClick={(e) => handleClick(slug.toString())}
          >
            
            <div
              className={`relative w-24 h-24 lg:w-12 lg:h-12 rounded-full transition border-4 lg:border-2 ${
                isActiveTab
                  ? "border-primary-color"
                  : "border-gray-300 lg:border-gray-400"
              }`}
            >
              <Image
                src={img}
                alt={slug}
                className="absolute w-full h-full"
                width={0}
                height={50}
              />
              {!isActiveTab && (
                <div className="absolute w-full h-full rounded-full bg-gray-300/60 lg:border-gray-400/60"></div>
              )}
            </div>
            <h2
              className={`text-white lg:text-black text-[0.70rem] text-center font-semibold uppercase pt-2 pb-1 transition border-b-4 ${
                isActiveTab ? "border-primary-color" : "border-transparent"
              }`}
            >
              {title}
            </h2>
          </Link>
        );
      })}
    </div>
  );
}
